import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { take } from 'rxjs/internal/operators/take';
import { ConfirmationDialogComponent } from '../../../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { SendReportFormComponent } from '../../send-report-form/send-report-form.component';
import { TagsDropAssignService } from '../../../../../shared/services/tags-drop-assign.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
	selector: 'app-contract-notices-toolbar',
	standalone: true,
	imports: [MatToolbarModule, MatDividerModule, MatButtonModule, TranslateModule, MatTooltipModule, MatIconModule],
	templateUrl: './contract-notices-toolbar.component.html',
	styleUrl: './contract-notices-toolbar.component.scss',
})
export class ContractNoticesToolbarComponent implements OnChanges {
	@Input() scrollToTop: boolean = false;
	@Input() totalItemsCount: number = 0;
	@Input() selectedItems: any;
	@Input() dataAdministrationType: 'CONTRACT_NOTICES' | 'CONTRACT_ANNOUNCEMENTS' = 'CONTRACT_NOTICES';
	// Autotag UI feature flag (backend `autotag.ui.enabled`) - gates the "approve the safe ones"
	// button so the toolbar looks exactly as today when it's false.
	@Input() autotagUiEnabled: boolean = false;
	@Output() actionRequested: EventEmitter<any> = new EventEmitter();

	constructor(private matDialog: MatDialog, public tagsDropAssign: TagsDropAssignService) {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['selectedItems']) {
			this.selectedItems = changes['selectedItems'].currentValue;
		}
	}

	checkValidity(type: 'SEND_TO_CLIENTS' | 'DELETE' | 'ADD_TAGS' | 'COPY_TAGS' | 'COPY') {
		switch (type) {
			case 'SEND_TO_CLIENTS':
			case 'DELETE':
			case 'COPY': {
				return this.selectedItems.length;
			}
			case 'ADD_TAGS': {
				return this.selectedItems.length && this.tagsDropAssign.manuallyselectedTags && this.tagsDropAssign.manuallyselectedTags.length;
			}
			case 'COPY_TAGS': {
				return (
					this.selectedItems.length === 2 &&
					((this.selectedItems[0].tags.length === 0 && this.selectedItems[1].tags.length > 0) || (this.selectedItems[1].tags.length === 0 && this.selectedItems[0].tags.length > 0))
				);
			}
		}
	}

	itemAction(action: 'SEND_TO_CLIENTS' | 'DELETE' | 'ADD_TAGS' | 'SCROLL_TO_TOP' | 'COPY_TAGS' | 'COPY' | 'UNSELECT_ALL' | 'REVIEW_BULK') {
		switch (action) {
			case 'SEND_TO_CLIENTS': {
				const dialogRef = this.matDialog.open(SendReportFormComponent, {
					width: '600px',
					data: {
						selectedItems: this.selectedItems,
						dataAdministrationType: this.dataAdministrationType,
					},
				});

				// dialogRef
				// 	.afterClosed()
				// 	.pipe(take(1))
				// 	.subscribe(() => {
				// 		this.actionRequested.emit({ action: 'FILTER' });
				// 	});
				break;
			}
			case 'DELETE': {
				const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
					width: '600px',
					data: {
						type: 'delete-confirmation',
						mode: 'DELETE',
					},
				});

				dialogRef
					.afterClosed()
					.pipe(take(1))
					.subscribe(result => {
						if (result) {
							this.actionRequested.emit({
								action: 'TOOLBAR',
								groupAction: action,
							});
						}
					});
				break;
			}
			case 'UNSELECT_ALL': {
				this.actionRequested.emit({
					action: 'UNSELECT_ALL',
				});
				break;
			}
			default: {
				this.actionRequested.emit({
					action: 'TOOLBAR',
					groupAction: action,
					tags: this.tagsDropAssign.manuallyselectedTags,
				});
			}
		}
	}
}
